import { h, Host } from "@stencil/core";
export class OffcanvasNext {
    onClick(event) {
        event.preventDefault();
        const parent = this.el.parentElement;
        parent.scrollTo(0, 0);
        parent.classList.add('offcanvas-child-active');
        this.el.nextElementSibling.classList.add('offcanvas-item-active');
    }
    render() {
        return h(Host, { key: '76e72614c130e3275ff1b5b0efe66b739fbf2166', role: "button", class: {
                'offcanvas-link': true
            } }, h("slot", { key: 'ec65d373eb4d8b2d045f267528dd679a3db6eaa7' }));
    }
    static get is() { return "uvex-offcanvas-next"; }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=offcanvas-next.js.map
